import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import PaperDraggable from "../../PaperDraggable";
import { formatarValorMonetario } from "../../../helpers/masks";

export default function DialogConfirmacao({
    open,
    valor,
    onSubmit,
    onClose,
    nomeFormaRecebimento
}: DialogConfirmacaoProps) {


    const handleClickSubmit = () => {
        onSubmit();
    }


    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            maxWidth={"xs"}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Confirmar forma de recebimento
            </DialogTitle>

            <DialogContent>
                <Typography variant="subtitle1">
                    Deseja confirmar o recebimento de <b>{formatarValorMonetario(valor)}</b> através de <b>{nomeFormaRecebimento}</b>?
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary">  Cancelar</Button>
                <Button
                    onClick={handleClickSubmit}
                    variant="contained"
                    color="primary"
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogConfirmacaoProps {
    open: boolean;
    onClose: () => void;
    onSubmit: () => void;
    valor: number;
    nomeFormaRecebimento?: string;
}